import Layout from '@/layout'
const asyncOtherStockManagementRoutes =
{
  path: '/stock/otherStockManagement',
  component: Layout,
  redirect: 'noredirect',
  name: '其他库存管理',
  funcPerms: 'stock:other',
  alwaysShow: true,
  meta: {
    title: '其他库存管理',
    icon: 'other',
    affix: false,
    noCache: true
  },
  children: [
    {
      path: 'other/inventoryQuery',
      component: () => import('@/views/oa/otherStockManagement/inventoryQuery/index'),
      funcPerms: 'stock:other:stock:query',
      name: 'other/inventoryQuery',
      meta: {
        title: '库存查询',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    // {
    //   path: 'other/purchasePlan',
    //   component: () => import('@/views/oa/otherStockManagement/purchasePlan/index'),
    //   funcPerms: 'oa:other:purchasePlan',
    //   name: 'otherPurchasePlan',
    //   meta: {
    //     title: '其他物品采购计划',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: 'other/purchasePlan/view',
    //   component: () => import('@/views/oa/otherStockManagement/purchasePlan/view'),
    //   funcPerms: 'oa:other:purchasePlan',
    //   name: 'otherPurchasePlanView',
    //   hidden: true,
    //   meta: {
    //     title: '查看其他物品采购计划',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: 'other/purchasePlan/viewSummary',
    //   component: () => import('@/views/oa/otherStockManagement/purchasePlan/viewSummary'),
    //   funcPerms: 'oa:other:purchasePlan',
    //   name: 'otherPurchaseViewSummary',
    //   hidden: true,
    //   meta: {
    //     title: '查看汇总',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: 'other/purchasePlan/detail',
    //   component: () => import('@/views/oa/otherStockManagement/purchasePlan/detail'),
    //   funcPerms: 'oa:other:purchasePlan',
    //   name: 'otherPurchasePlanDetail',
    //   hidden: true,
    //   meta: {
    //     title: '查看明细',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: 'other/purchasePlan/submitReview',
    //   component: () => import('@/views/oa/otherStockManagement/purchasePlan/submitReview'),
    //   funcPerms: 'oa:other:purchasePlan',
    //   name: 'otherPurchasePlan-submitReview',
    //   hidden: true,
    //   meta: {
    //     title: '提交审核',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: 'other/purchase',
    //   component: () => import('@/views/oa/otherStockManagement/purchase/index'),
    //   funcPerms: 'oa:other:purchaseApply',
    //   name: 'otherPurchase',
    //   meta: {
    //     title: '其他物品采购',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: 'other/purchase/add',
    //   component: () => import('@/views/oa/otherStockManagement/purchase/add'),
    //   funcPerms: 'oa:other:purchaseApply',
    //   name: 'OtherPurchaseApplicationAdd',
    //   hidden: true,
    //   meta: {
    //     title: '新增采购申请',
    //     icon: 'index',
    //     affix: false,
    //     noCache: false
    //   }
    // },
    // {
    //   path: 'other/purchase/edit',
    //   component: () => import('@/views/oa/otherStockManagement/purchase/add'),
    //   funcPerms: 'oa:other:purchaseApply',
    //   name: 'OtherPurchaseApplicationEdit',
    //   hidden: true,
    //   meta: {
    //     title: '编辑采购申请',
    //     icon: 'index',
    //     affix: false,
    //     noCache: false
    //   }
    // },
    // {
    //   path: 'other/purchase/view',
    //   component: () => import('@/views/oa/otherStockManagement/purchase/view'),
    //   funcPerms: 'oa:other:purchaseApply',
    //   name: 'otherPurchaseApplication-view',
    //   hidden: true,
    //   meta: {
    //     title: '查看采购申请',
    //     icon: 'index',
    //     affix: false,
    //     noCache: false
    //   }
    // },
    // {
    //   path: 'other/purchaseReview',
    //   component: () => import('@/views/oa/otherStockManagement/purchaseReview/index'),
    //   funcPerms: 'oa:other:purchaseReview',
    //   name: 'otherPurchaseReview',
    //   meta: {
    //     title: '其他物品采购审核',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: 'other/purchaseReview/view',
    //   component: () => import('@/views/oa/otherStockManagement/purchaseReview/view'),
    //   funcPerms: 'oa:other:purchaseReview',
    //   name: 'otherPurchaseReview-view',
    //   hidden: true,
    //   meta: {
    //     title: '查看其他物品采购审核',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    {
      path: 'other/inventoryDetails',
      component: () => import('@/views/oa/otherStockManagement/inventoryDetails/index'),
      funcPerms: 'stock:other:stockin:detail',
      name: 'other/inventoryDetails',
      meta: {
        title: '入库明细',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'other/OutboundDetail',
      component: () => import('@/views/oa/otherStockManagement/OutboundDetail/index'),
      funcPerms: 'stock:other:stockout:detail',
      name: 'other/OutboundDetail',
      meta: {
        title: '出库明细',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'other/deptUseApply',
      component: () => import('@/views/oa/otherStockManagement/deptUseApply/index'),
      funcPerms: 'stock:other:useApply',
      name: 'other/deptUseApply',
      meta: {
        title: '使用申领',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'other/deptUseApply/query',
      component: () => import('@/views/oa/otherStockManagement/deptUseApply/query'),
      funcPerms: 'stock:other:useApply',
      name: 'other/deptUseApplyQuery',
      hidden: true,
      meta: {
        title: '查询库存',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'other/deptUseApplyVerify',
      component: () => import('@/views/oa/otherStockManagement/deptUseApplyVerify/index'),
      funcPerms: 'stock:other:applyAudit',
      name: 'other/deptUseApplyVerify',
      meta: {
        title: '申领审核',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'other/inventoryImport',
      component: () => import('@/views/oa/otherStockManagement/inventoryImport/index'),
      funcPerms: 'stock:other:stockImport',
      name: 'other/inventoryImport',
      meta: {
        title: '库存导入',
        icon: 'index',
        affix: false,
        noCache: true
      }
    }
  ]
}

export default asyncOtherStockManagementRoutes
